export default __webpack_public_path__ + "static/media/scotiabank-2.31ac056a.JPG";